// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ciam-titlebar{width:100%;height:45px;padding:15px;position:relative;font-size:1rem;line-height:16px;color:#fff;background-color:#000}", ""]);
// Exports
module.exports = exports;
